import { Radio as RadioPrimitive } from '@base-ui/react/radio';
import { RadioGroup as RadioGroupPrimitive } from '@base-ui/react/radio-group';
import { cn } from '@mdvip/shared/lib/utils';
import '@mdvip/shared/lib/uiModality';

function RadioGroup({ className, ...props }: RadioGroupPrimitive.Props) {
  return <RadioGroupPrimitive data-slot="radio-group" className={cn('grid w-full gap-3', className)} {...props} />;
}

function RadioGroupItem({ className, ...props }: RadioPrimitive.Root.Props) {
  return (
    <RadioPrimitive.Root
      data-slot="radio-group-item"
      className={cn(
        // Border color is deliberately static across states (see tokens.css's plain-CSS
        // `[data-slot="radio-group-item"]` rule: "one color in every state, orange on hover") --
        // matches the DS's own _radio-group.tsx, which has no checked-state border override
        // either. Only the inner dot communicates "checked."
        'group/radio-group-item peer relative flex aspect-square size-5 shrink-0 rounded-full border border-input outline-none after:absolute after:-inset-x-3 after:-inset-y-2 [@media(pointer:coarse)]:after:-inset-x-3.5 [@media(pointer:coarse)]:after:-inset-y-3.5 data-disabled:cursor-not-allowed data-disabled:opacity-50 aria-invalid:border-2 aria-invalid:border-destructive-foreground aria-invalid:bg-[color-mix(in_oklab,var(--destructive)_14%,var(--card))] aria-invalid:aria-checked:border-primary dark:bg-input/30',
        className,
      )}
      {...props}
    >
      <RadioPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="flex size-full items-center justify-center"
      >
        <span className="absolute top-1/2 left-1/2 size-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary" />
      </RadioPrimitive.Indicator>
    </RadioPrimitive.Root>
  );
}

export { RadioGroup, RadioGroupItem };
